import React from "react";
import "../css/contact.css"; // Import your CSS file
import NavBar from "./nav";
import Footer from "./footer";

const Contact = () => {
  return (
    <div>
      <NavBar />
      <div className="hero-section">
        <h1 className="hero-title">Contact Us</h1>
        <p className="hero-subtitle">
          We're here to help! Reach out to us for any inquiries or assistance.
        </p>
      </div>

      <div className="contact-page">
        {/* Hero Section */}

        {/* Contact Content */}
        <div className="contact-page__container">
          <div className="contact-page__content">
            {/* Contact Form */}
            <div className="contact-page__form">
              <h2 className="contact-page__form-title">Send Us a Message</h2>
              <form>
                <div className="contact-page__form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Your Name"
                    required
                  />
                </div>
                <div className="contact-page__form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Your Email"
                    required
                  />
                </div>
                <div className="contact-page__form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    placeholder="Your Message"
                    rows="5"
                    required
                  />
                </div>
                <button type="submit" className="contact-page__submit-button">
                  Send Message
                </button>
              </form>
            </div>

            {/* Contact Details */}
            <div className="contact-page__details">
              <h2 className="contact-page__details-title">
                Contact Information
              </h2>
              <div className="contact-page__details-group">
                <h3 className="contact-page__details-subtitle">Address</h3>
                <p className="contact-page__details-text">
                  123 Kimberley Street, Kimberley, South Africa
                </p>
              </div>
              <div className="contact-page__details-group">
                <h3 className="contact-page__details-subtitle">Phone</h3>
                <p className="contact-page__details-text">+27 53 123 4567</p>
              </div>
              <div className="contact-page__details-group">
                <h3 className="contact-page__details-subtitle">Email</h3>
                <p className="contact-page__details-text">
                  info@kimberleyhelp.com
                </p>
              </div>
              <div className="contact-page__details-group">
                <h3 className="contact-page__details-subtitle">
                  Working Hours
                </h3>
                <p className="contact-page__details-text">
                  Mon - Fri: 8:00 AM - 5:00 PM
                </p>
              </div>
            </div>
          </div>

          {/* Map Section */}
          <div className="contact-page__map">
            <iframe
              title="Kimberley Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3440.23123456789!2d24.758915315035!3d-28.738982982345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e9b06f0b8b8b8b9%3A0x1e9b06f0b8b8b8b9!2sKimberley%2C%20South%20Africa!5e0!3m2!1sen!2sza!4v1631234567890!5m2!1sen!2sza"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
